import SelectField from 'components/Inputs/SelectField/SelectField';
import { useMemo } from 'react';
import { useCityQuery } from 'utils/queries/location';
import { LocationSelectProps } from '.';

type CitySelectProps = LocationSelectProps & {
	provinceId?: string;
};

const CitySelect: React.FC<CitySelectProps> = ({
	control,
	name,
	label = 'Municipality/City',
	provinceId,
	disabled,
	onChange,
	defaultValue,
	isFromChannel = false,
	...rest
}) => {
	const { data, isLoading } = useCityQuery(
		'cities',
		{ provinceId },
		{ enabled: !!provinceId }
	);

	const options = useMemo(() => {
		return (
			data?.map(({ id: value, name: label }) => ({
				label,
				value,
			})) || []
		);
	}, [data]);

	return (
		<SelectField
			label={label}
			control={control}
			name={isFromChannel ? name : `${name}.city`}
			required
			isLoading={isLoading}
			options={options}
			disabled={disabled}
			onChange={(v) => onChange(v, options)}
			defaultValue={defaultValue}
			{...rest}
		/>
	);
};

export default CitySelect;
